import useObjectStatusStore from "../../../Store/ObjectStatus";
import { LocationsEnum } from "../../../Store/ObjectStatusEnum";
import LocationView from "../../LocationView/components/LocationView";
import './StatusDashboard.css'

function StatusDashboard() {

    const location = useObjectStatusStore((state) => state.location)

    let imageurl = ''
    switch (location) {
        case LocationsEnum.KCSiR:
            imageurl = process.env.PUBLIC_URL + '/assets/kcsir.jpg'
            break;
        case LocationsEnum.Ratusz:
            imageurl = process.env.PUBLIC_URL + '/assets/kwidzynRatusz.jpg'
            break;
        default:
            break;
    }

    return (
        <div className="StatusDashboard">
            <div className="side">
                <LocationView imageurl={imageurl} />
            </div>
            <div className="side">
                <div className="RestrictionsText">
                    <p>Obowiązujące ograniczenia</p>
                </div>
                {/* <div className="RestrictionsSigns">
                    <ProhibitionLimitSign textDisplay={'10'} />
                    <ProhibitionLimitSign textDisplay={'88'} textSubDisplay={'t'} />
                </div> */}
            </div>

        </div >
    )
}

export default StatusDashboard;